
import { email, required, maxLength, minLength, helpers, sameAs } from '@vuelidate/validators';

export function mandatory(model) {
  return helpers.withMessage(
    `${model} is required`,
    required
  );
}

export function minSize(model, len) {
  return helpers.withMessage(
    `${model} should be at least ${len} characters long`,
    minLength(len)
  );
}

export function maxSize(model, len) {
  return helpers.withMessage(
    `The maximum length allowed for ${model} is ${len} characters`,
    maxLength(len)
  );
}
